(function() {
  'use strict';
  
  // Detect if we're on a C:Hub proxy URL
  function isProxyPage() {
    const path = window.location.pathname;
    return path.includes('/apps/chub/') || 
           (path.startsWith('/account/') && path !== '/account') ||
           path.startsWith('/a/');
  }
  
  // Get the cart drawer element
  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }
  
  // Suppress error messages temporarily during refresh
  function suppressCartErrors(suppress = true) {
    const errorElements = document.querySelectorAll('#CartDrawer-CartErrors, .cart-item__error');
    errorElements.forEach(el => {
      if (suppress) {
        el.style.display = 'none';
        el.setAttribute('data-suppressed', 'true');
      } else {
        if (el.getAttribute('data-suppressed') === 'true') {
          el.style.display = '';
          el.removeAttribute('data-suppressed');
        }
      }
    });
  }
  
  // Fetch updated cart sections and refresh the drawer
  async function refreshCartDrawer() {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;
    
    suppressCartErrors(true);
    
    try {
      const sections = cartDrawer.getSectionsToRender();
      const sectionsUrl = sections.map(section => section.id).join(',');
      
      const response = await fetch(`${window.Shopify.routes.root}?sections=${sectionsUrl}`);
      const sectionsHTML = await response.json();
      
      const parsedState = {
        id: null,
        sections: sectionsHTML
      };
      
      cartDrawer.renderContents(parsedState);
      
      setTimeout(() => {
        suppressCartErrors(false);
      }, 100);
      
    } catch (error) {
      console.warn('Cart drawer refresh failed:', error);
      suppressCartErrors(false);
    }
  }
  
  // Make cart icon toggle the drawer (open/close) - WORKS SITE-WIDE
  function setupCartIconToggle() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) {
      setTimeout(setupCartIconToggle, 100);
      return;
    }
    
    // Check if already set up
    if (cartLink._toggleSetup) {
      return;
    }
    
    const cartDrawer = getCartDrawer();
    if (!cartDrawer) {
      setTimeout(setupCartIconToggle, 100);
      return;
    }
    
    // Remove existing click listeners by cloning the element
    const newCartLink = cartLink.cloneNode(true);
    cartLink.parentNode.replaceChild(newCartLink, cartLink);
    
    // Add toggle functionality
    newCartLink.addEventListener('click', function(event) {
      event.preventDefault();
      
      // Check if drawer is open
      if (cartDrawer.classList.contains('active')) {
        cartDrawer.close();
      } else {
        cartDrawer.open(newCartLink);
      }
    });
    
    // Also handle keyboard (space key)
    newCartLink.addEventListener('keydown', function(event) {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        
        if (cartDrawer.classList.contains('active')) {
          cartDrawer.close();
        } else {
          cartDrawer.open(newCartLink);
        }
      }
    });
    
    newCartLink._toggleSetup = true;
  }
  
  // Initialize cart icon toggle (site-wide, not just proxy pages)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCartIconToggle);
  } else {
    setTimeout(setupCartIconToggle, 100);
  }
  
  // ===== PROXY PAGE SPECIFIC CODE BELOW =====
  
  // Only run proxy-specific fixes on proxy pages
  if (!isProxyPage()) {
    return;
  }
  
  // Track active cart updates
  let activeCartUpdate = false;
  
  // Set up blocking on cart-drawer-items element
  function setupBlocking() {
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (!cartDrawerItems) {
      setTimeout(setupBlocking, 100);
      return;
    }
    
    if (cartDrawerItems._proxyFixSetup) {
      return;
    }
    
    const originalGetSectionsToRender = cartDrawerItems.getSectionsToRender.bind(cartDrawerItems);
    const originalGetSectionInnerHTML = cartDrawerItems.getSectionInnerHTML.bind(cartDrawerItems);
    
    cartDrawerItems.getSectionsToRender = function() {
      if (activeCartUpdate) {
        return []; // Empty array prevents forEach
      }
      return originalGetSectionsToRender();
    };
    
    cartDrawerItems.getSectionInnerHTML = function(html, selector) {
      if (activeCartUpdate) {
        return ''; // Empty string prevents innerHTML update
      }
      return originalGetSectionInnerHTML(html, selector);
    };
    
    cartDrawerItems._proxyFixSetup = true;
  }
  
  // Intercept updateQuantity
  function interceptUpdateQuantity() {
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (!cartDrawerItems || !cartDrawerItems.updateQuantity) {
      setTimeout(interceptUpdateQuantity, 100);
      return;
    }
    
    if (cartDrawerItems.updateQuantity._intercepted) {
      return;
    }
    
    const originalUpdateQuantity = cartDrawerItems.updateQuantity.bind(cartDrawerItems);
    
    cartDrawerItems.updateQuantity = function(line, quantity, event, name, variantId) {
      // Block native updates immediately
      activeCartUpdate = true;
      suppressCartErrors(true);
      
      if (this.enableLoading) {
        this.enableLoading(line);
      }
      
      const result = originalUpdateQuantity(line, quantity, event, name, variantId);
      
      if (result && typeof result.then === 'function') {
        return result.then((parsedState) => {
          if (parsedState && !parsedState.errors) {
            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            const cartFooter = document.getElementById('main-cart-footer');
            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          }
          
          if (this.disableLoading) {
            this.disableLoading(line);
          }
          
          // Refresh after a brief delay
          setTimeout(() => {
            refreshCartDrawer().then(() => {
              activeCartUpdate = false;
            });
          }, 50);
          
          return parsedState;
        }).catch((error) => {
          activeCartUpdate = false;
          suppressCartErrors(false);
          throw error;
        });
      }
      
      return result;
    };
    
    cartDrawerItems.updateQuantity._intercepted = true;
  }
  
  // Initialize proxy-specific fixes
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupBlocking();
      interceptUpdateQuantity();
    });
  } else {
    setupBlocking();
    interceptUpdateQuantity();
  }
  
  // Intercept fetch requests
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    const isCartChange = typeof url === 'string' && url.includes('/cart/change');
    const isCartRequest = typeof url === 'string' && (
      url.includes('/cart/add') ||
      url.includes('/cart/update') ||
      url.includes('/cart/change') ||
      url.includes('/cart/clear')
    );
    
    if (isCartChange) {
      activeCartUpdate = true;
      suppressCartErrors(true);
    }
    
    return originalFetch.apply(this, args).then(async (response) => {
      if (isCartChange && response.ok) {
        setTimeout(() => {
          refreshCartDrawer().then(() => {
            activeCartUpdate = false;
          });
        }, 100);
      } else if (isCartRequest && response.ok) {
        suppressCartErrors(true);
        setTimeout(refreshCartDrawer, 200);
      }
      return response;
    });
  };
  
  // Listen for form submissions
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form && form.action && (
      form.action.includes('/cart/add') ||
      form.action.includes('/cart/update') ||
      form.action.includes('/cart/change')
    )) {
      suppressCartErrors(true);
      setTimeout(refreshCartDrawer, 400);
    }
  }, true);
  
  // Listen for custom cart events
  document.addEventListener('cart:updated', function() {
    suppressCartErrors(true);
    setTimeout(refreshCartDrawer, 200);
  });
  document.addEventListener('cart:refresh', refreshCartDrawer);
  
  const cartDrawer = getCartDrawer();
  if (cartDrawer) {
    cartDrawer.addEventListener('cart:updated', function() {
      suppressCartErrors(true);
      setTimeout(refreshCartDrawer, 200);
    });
    cartDrawer.addEventListener('cart:refresh', refreshCartDrawer);
  }
})();